export var tokensLegion = {
    mediaScreenLG: '1200px',
    mediaScreenMD: '1024px',
    mediaScreenSM: '678px',
    mediaScreenXS: '480px',
    transparent: 'transparent',
    primary25: '#FBFAFF',
    primary50: '#F5F3FF',
    primary100: '#ECE9FE',
    primary200: '#DDD6FE',
    primary300: '#C3B5FD',
    primary400: '#A48AFB',
    primary500: '#875BF7',
    primary600: '#7839EE',
    primary700: '#6927DA',
    primary800: '#5720B7',
    primary900: '#491C96',
    secondary25: '#F5F8FF',
    secondary50: '#EFF4FF',
    secondary100: '#D1E0FF',
    secondary200: '#B2CCFF',
    secondary300: '#84ADFF',
    secondary400: '#528BFF',
    secondary500: '#2970FF',
    secondary600: '#155EEF',
    secondary700: '#004EEB',
    secondary800: '#0040C1',
    secondary900: '#00359E',
    tertiary25: '#FCFCFD',
    tertiary50: '#F9FAFB',
    tertiary100: '#F2F4F7',
    tertiary200: '#EAECF0',
    tertiary300: '#D0D5DD',
    tertiary400: '#98A2B3',
    tertiary500: '#667085',
    tertiary600: '#475467',
    tertiary700: '#344054',
    tertiary800: '#1D2939',
    tertiary900: '#101828',
    error25: '#FFFBFA',
    error50: '#FEF3F2',
    error100: '#FEE4E2',
    error200: '#FECDCA',
    error300: '#FDA29B',
    error400: '#F97066',
    error500: '#F04438',
    error600: '#D92D20',
    error700: '#B42318',
    error800: '#912018',
    error900: '#7A271A',
    warning25: '#FFFCF5',
    warning50: '#FFFAEB',
    warning100: '#FEF0C7',
    warning200: '#FEDF89',
    warning300: '#FEC84B',
    warning400: '#FDB022',
    warning500: '#F79009',
    warning600: '#DC6803',
    warning700: '#B54708',
    warning800: '#93370D',
    warning900: '#7A2E0E',
    success25: '#F6FEF9',
    success50: '#ECFDF3',
    success100: '#D1FADF',
    success200: '#A6F4C5',
    success300: '#6CE9A6',
    success400: '#32D583',
    success500: '#12B76A',
    success600: '#039855',
    success700: '#027A48',
    success800: '#05603A',
    success900: '#054F31',
    information25: '#F5FAFF',
    information50: '#EFF8FF',
    information100: '#D1E9FF',
    information200: '#B2DDFF',
    information300: '#84CAFF',
    information400: '#53B1FD',
    information500: '#2E90FA',
    information600: '#1570EF',
    information700: '#175CD3',
    information800: '#1849A9',
    information900: '#194185',
    basewhite: '#ffffff',
    baseblack: '#212121',
    typographyHeading: 'Nunito Sans',
    typographyBody: 'Nunito Sans',
    radius1: '2',
    radius2: '4',
    radius3: '6',
    radius4: '8',
    radius5: '12',
    radius6: '16',
    radius7: '24',
    radius8: '500',
    alertErrorBackgroundColor: '#fef9f8',
    alertErrorColor: '#f04438',
    alertErrorDescColor: '#616161',
    alertErrorTitleColor: '#3d3d3d',
    alertInformationBackgroundColor: '#f5fbff',
    alertInformationColor: '#0ba5ec',
    alertInformationDescColor: '#616161',
    alertInformationTitleColor: '#3d3d3d',
    alertSuccessBackgroundColor: '#f6fef9',
    alertSuccessColor: '#12b76a',
    alertSuccessDescColor: '#616161',
    alertSuccessTitleColor: '#3d3d3d',
    alertWarningBackgroundColor: '#fefaf8',
    alertWarningColor: '#f79009',
    alertWarningDescColor: '#616161',
    alertWarningTitleColor: '#3d3d3d',
    anchorDefaultColor: '#875BF7',
    anchorHoverColor: '#7839EE',
    anchorActiveColor: '#6927DA',
    anchorFocusColor: '#875BF7',
    anchorDisableColor: '#98A2B3',
    buttonSolidDefaultBackgroundColor: '#875BF7',
    buttonSolidDefaultColor: '#ffffff',
    buttonSolidHoverBackgroundColor: '#7839EE',
    buttonSolidHoverColor: '#ffffff',
    buttonSolidActiveBackgroundColor: '#6927DA',
    buttonSolidActiveColor: '#ffffff',
    buttonSolidFocusBackgroundColors: '#875BF7',
    buttonSolidFocusColor: '#ffffff',
    buttonSolidFocusBorderColors: '#A48AFB',
    buttonSolidDisabledBackgroundColor: '#D0D5DD',
    buttonSolidDisabledColor: '#667085',
    buttonSoftDefaultBackgroundColor: '#F5F3FF',
    buttonSoftDefaultColor: '#875BF7',
    buttonSoftHoverBackgroundColor: '#DDD6FE',
    buttonSoftHoverColor: '#7839EE',
    buttonSoftActiveBackgroundColor: '#C3B5FD',
    buttonSoftActiveColor: '#6927DA',
    buttonSoftFocusBackgroundColor: '#F5F3FF',
    buttonSoftFocusColor: '#875BF7',
    buttonSoftFocusBorderColors: '#A48AFB',
    buttonSoftDisabledBackgroundColor: '#EAECF0',
    buttonSoftDisabledColor: '#667085',
    buttonBorderRadius: '6',
    checkboxDefaultBackgroundColor: '#ffffff',
    checkboxDefaultBorder: '#DDD6FE',
    checkboxDisabledBackgroundColor: '#F9FAFB',
    checkboxDisabledBorder: '#D0D5DD',
    checkboxActivedisableBackgroundColor: '#DDD6FE',
    checkboxActivedisableColor: '#ffffff',
    checkboxActivedisableBorder: '#DDD6FE',
    checkboxActiveBackgroundColor: '#875BF7',
    checkboxActiveColor: '#ffffff',
    checkboxActiveBorder: '#DDD6FE',
    checkboxBorderRadius: '4',
    fieldDefaultBackgroundColor: '#ffffff',
    fieldDefaultOutlineColor: '#D0D5DD',
    fieldDefaultIconColor: '#1D2939',
    fieldDefaultPlaceholderColor: '#D0D5DD',
    fieldDefaultLabelColor: '#1D2939',
    fieldActiveOutlineColor: '#875BF7',
    fieldActivePlaceholderColor: '#1D2939',
    fieldActiveBorderColor: '#ECE9FE',
    fieldErrorOutlineColor: 'error500',
    fieldSuccessOutlineColor: '#12B76A',
    fieldDisableBackgroundColor: '#F9FAFB',
    fieldDisableOutlineColor: '#D0D5DD',
    fieldDisablePlaceholderColor: '#98A2B3',
    fieldPrefixsufixLineColor: '#EAECF0',
    fieldPrefixsufixtextColor: '#1D2939',
    fieldBorderRadius: '6',
    fieldDefaultselectColor: '#475467',
    fieldActiveselectBackgroundColor: '#F5F3FF',
    fieldActiveselectColor: '#875BF7',
    radioDefaultBackgroundColor: '#ffffff',
    radioDefaultBorder: '#D0D5DD',
    radioDisableBackgroundColor: '#F9FAFB',
    radioDisableBorder: '#D0D5DD',
    radioActiveBackgroundColor: '#875BF7',
    radioActiveBorder: '#875BF7',
    radioActivedisableBackgroundColor: '#C3B5FD',
    radioActivedisableBorder: '#C3B5FD',
    switchActiveBackgroundColor: '#12B76A',
    switchActivedisableBackgroundColor: '#D1FADF',
    switchNonactiveBackgroundColor: '#98A2B3',
    switchNonactivedisableBackgroundColor: '#EAECF0',
    sidebarDefaultColor: '#344054',
    sidebarDefaultBackgroundColor: '#ffffff',
    sidebarDefaultIconColor: '#98A2B3',
    sidebarHoverBackgroundColor: '#ECE9FE',
    sidebarHoverColor: '#344054',
    sidebarActiveBackgroundColor: '#F5F3FF',
    sidebarActiveColor: '#875BF7'
};
